import Vue from 'vue';
import LinkShareModal from './LinkShareModal.vue';
import resolve from './resolve';
import { ShareOptions } from './types';

export interface ModalOptions {
  title: string;
  message: string;
}

const getDefaultShareOptions = (): ShareOptions => ({
  url: resolve.currentUrl(),
});

export default new Vue({
  methods: {
    openModal(
      modalOptions: ModalOptions = {} as ModalOptions,
      shareOptions: ShareOptions = getDefaultShareOptions(),
      callbackFn: CallableFunction = (): void => { /**/ },
    ): void {
      this.$modal.show(LinkShareModal, {
        title: modalOptions.title,
        message: modalOptions.message,
        shareOptions,
        callbackFn,
      }, {
        width: '95%',
        maxWidth: 600,
        height: 'auto',
        adaptive: true,
        scrollable: true,
      });
    },
  },
});
